export type RedisKey = string & {
  __CarSearchRedisKey: null;
};

export function createRedisKey<T>(array: T[]) {
  return array.join('-') as RedisKey;
}
